import { Card, cardNull } from './card'

export interface Trick {
  readonly userId: string
  readonly trickRoundNumber: number
  readonly card: Card
}

export const trickNull: Trick = {
  userId: '',
  trickRoundNumber: 0,
  card: cardNull,
}
